import React, { useEffect, useState } from 'react';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { Table, Drawer, Popconfirm } from 'antd';
import { EditOutlined } from '@ant-design/icons';
import H3Text from '@Uilib/h3Text';
import H3Image from '@Uilib/h3Image';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import closeIcon from '@Images/icons/icon-close-blue.png';
import './style.scss';
import { CreateDocSequence, GetDocSequence, MarkAsDefault, UpdateDocSequence } from '../../../../modules/documentSequence';
import DocumentSequenceForm from './documentSequenceForm';

const DocumentSequenceV2 = ({ getDocSequence, markAsDefaultLoading, entityName, documentSequenceLoading, user, createDocSequence, createDocSequenceLoading, UpdateDocSequence, updateDocSequenceLoading, markAsDefault }) => {
  const [showSequenceDrawer, setShowSequenceDrawer] = useState(false);
  const [sequenceData, setSequenceData] = useState(null);
  const [selectedSequence, setSelectedSequence] = useState(null);
  const [currentActionType, setCurrentActionType] = useState(null);
  const [call, setCall] = useState(false);

  useEffect(() => {
    if (user?.tenant_info?.tenant_id && entityName) {
      getDocSequence({
        query: {
          tenant_id: user.tenant_info.tenant_id,
          entity_name: entityName || '',
        },
      }, (data) => {
        setSequenceData(data);
      });
    }
  }, [user?.tenant_info?.tenant_id, call, entityName]);


  const uomListColumns = [
    {
      title: 'PREFIX',
      render: (_, record) => record?.seq_prefix || '-',
    },
    {
      title: 'CURRENT SEQUENCE',
      render: (_, record) => record?.seq_counter || '0',
    },
    {
      title: '',
      key: 'action',
      render: (_, record) => (
        <div
          style={{
            display: 'flex',
            justifyContent: 'flex-start',
            alignItems: 'center',
            gap: '12px',
          }}
        >
          <div
            style={{ color: '#1890ff' }}
            className="roundIconButton"
            onClick={() => {
              setCurrentActionType("update");
              setSelectedSequence(record);
              setShowSequenceDrawer(true);
            }}
          >
            <EditOutlined />
          </div>
          <Popconfirm
            title="Are you sure you want to make it default?"
            onConfirm={() => {
              const payload = {
                body: {
                  seq_id: record.seq_id,
                  tenant_id: user?.tenant_info?.tenant_id,
                  entity_name: entityName,
                },
              };
              markAsDefault(payload, (data) => {
                if (data) {
                  setCall(!call);
                }
              });
            }}
            okText="Yes"
            cancelText="No"
            disabled={record.is_default}
          >
            <span
              style={{ color: record.is_default ? 'rgb(26, 192, 93)' : '#1890ff', cursor: record.is_default ? 'not-allowed' : 'pointer' }}
            >
              {record.is_default ? 'Default Sequence' : 'Mark as Default'}
            </span>
          </Popconfirm>

        </div >
      ),
    }
  ];
  return (
    <>
      <div className="doc-sqn__wrapper">
        <div className="ant-row">
          <div className="ant-col-md-18 width-100-in-mobile">
            <div className="doc-sqn__table__wrapper">
              <div className="doc-sqn__table__data show-table-header-in-mobile">
                <Table
                  title={() => (
                    <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                      <H3Text
                        text={`${sequenceData?.count || 0} Document Sequences`}
                        className="document-sequence__title"
                      />
                      <H3Button
                        buttonType={defaultButtonTypes.BLUE_ROUNDED}
                        text="+ New Sequences"
                        onClick={() => {
                          setShowSequenceDrawer(true);
                          setCurrentActionType("create");
                        }}
                        customClass="create-new-template-button"
                      />
                    </div>
                  )}
                  loading={documentSequenceLoading || markAsDefaultLoading}
                  showHeader
                  size="small"
                  columns={uomListColumns}
                  dataSource={sequenceData?.document_sequences || []}
                  pagination={false}
                  bordered
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <Drawer
        open={showSequenceDrawer}
        width="480px"
        mask
        onClose={() => setShowSequenceDrawer(false)}
        destroyOnClose
      >
        <div className="custom-drawer__header-wrapper">
          <div className="custom-drawer__header" style={{ width: '425px' }}>
            <H3Text
              text={`${currentActionType === 'update' ? 'Update' : 'Create'} Sequence Number for ${entityName?.replaceAll('_', ' ').toProperCase()}`}
              className="custom-drawer__title"
            />
            <H3Image
              src={closeIcon}
              className="custom-drawer__close-icon"
              onClick={() => {
                setShowSequenceDrawer(false)
              }}
            />
          </div>
        </div>
        <div>
          <DocumentSequenceForm
            sequenceData={currentActionType === 'update' ? selectedSequence : ""}
            currentActionType={currentActionType}
            callback={() => {
              setShowSequenceDrawer(false);
              setCall(!call);
            }}
            createDocSequence={createDocSequence}
            UpdateDocSequence={UpdateDocSequence}
            loading={createDocSequenceLoading || updateDocSequenceLoading}
            user={user}
            entityName={entityName}
          />
        </div>
      </Drawer>
    </>
  );
};
const mapStateToProps = ({
  UserReducers, GetDocSequence, CreateDocSequence, UpdateDocSequence, MarkAsDefault
}) => ({
  user: UserReducers.user,
  documentSequence: GetDocSequence.data,
  documentSequenceLoading: GetDocSequence.loading,
  createDocSequenceLoading: CreateDocSequence.loading,
  updateDocSequenceLoading: UpdateDocSequence.loading,
  markAsDefaultLoading: MarkAsDefault.loading,
});
const mapDispatchToProps = (dispatch) => ({
  getDocSequence: (payload, callback) => dispatch(GetDocSequence.actions.request(payload, callback)),
  createDocSequence: (payload, callback) => dispatch(CreateDocSequence.actions.request(payload, callback)),
  UpdateDocSequence: (payload, callback) => dispatch(UpdateDocSequence.actions.request(payload, callback)),
  markAsDefault: (payload, callback) => dispatch(MarkAsDefault.actions.request(payload, callback)),
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DocumentSequenceV2));
